// extracted by mini-css-extract-plugin
export default {"dataTableFormat":"styles_dataTableFormat__L3yWI","formSpace":"styles_formSpace__e6VXX","actionButton":"styles_actionButton__K1dC+","actionIcon":"styles_actionIcon__9getS"};